import React, { useState } from 'react';
import ReactDOM from 'react-dom';

// A "Watch how" link that plays an mp4 in an in-app lightbox instead of
// opening the raw file in a new browser tab (which fills the whole screen
// with a bare video player). Pass-through className/style keep each call
// site's existing look; only the click behavior changes.
export default function VideoLink({ src, label = '▶ Watch how', className, style }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <a
        href={src}
        className={className}
        style={style}
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(true); }}
      >
        {label}
      </a>
      {open && ReactDOM.createPortal(
        <div
          onClick={() => setOpen(false)}
          style={{ position: 'fixed', inset: 0, zIndex: 10001, background: 'rgba(7,15,36,0.82)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, backdropFilter: 'blur(4px)' }}
        >
          <div onClick={e => e.stopPropagation()} style={{ position: 'relative', width: '100%', maxWidth: 920, borderRadius: 14, overflow: 'hidden', boxShadow: '0 30px 80px rgba(0,0,0,0.5)', background: '#000' }}>
            <button
              onClick={() => setOpen(false)}
              aria-label="Close video"
              style={{ position: 'absolute', top: 12, right: 12, zIndex: 2, width: 36, height: 36, borderRadius: '50%', border: 'none', background: 'rgba(0,0,0,0.55)', color: '#fff', fontSize: 20, lineHeight: 1, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >×</button>
            <video
              src={src}
              controls
              autoPlay
              playsInline
              style={{ display: 'block', width: '100%', height: 'auto', aspectRatio: '16 / 9', background: '#000' }}
            />
          </div>
        </div>,
        document.body
      )}
    </>
  );
}
